import React, { memo, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';

import TextLoader from '../../../components/text-loader/TextLoader';
import { ID8_TABS } from '../../../constants';
import useMessagesLoaderLabels from '../../../hooks/useMessagesLoaderLabels';
import { changeId8Tab, changeImagesTable, setEditableMessage } from '../../../redux/id8/id8Reducer';
import MessagesList from '../../../scout-new/components/message-output/MessagesList';
import parseId8Message from '../../../utils/parseId8Message';
import MessageCard from '../message-card/MessageCard';
import useIsMessagesGenerating from '../../hooks/useIsMessagesGenerating';

import scss from './MessagesOutput.module.scss';

const MessagesOutput = ({
  bindNextAction,
  onSearch,
  onLike,
  onSelect,
  onDelete,
  onRestore,
  onSaveMessage,
  getMessageLogs,
  maxHeight,
}) => {
  const { id } = useParams();
  const tableWrapperRef = useRef(null);
  const dispatch = useDispatch();

  const loaderLabels = useMessagesLoaderLabels();

  const { messagesContent, isMessagesLoading, tableSettings } = useSelector((state) => state.id8);
  const isGenerating = useIsMessagesGenerating();

  const handleUpdateTableData = async () => {
    onSearch?.({ id });
  };

  const handleOpenImages = (selectedMessage) => {
    const parsedMessage = parseId8Message(selectedMessage.message);
    dispatch(changeImagesTable({ searchQuery: parsedMessage.headline ?? '', page: 1, size: 8 }));
    dispatch(changeId8Tab(ID8_TABS.IMAGES));
  };

  useEffect(() => {
    if (onSearch && tableSettings) {
      handleUpdateTableData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tableSettings]);

  return (
    <div className={scss.tableWrapper} ref={tableWrapperRef}>
      <MessagesList
        content={messagesContent}
        isLoading={isMessagesLoading}
        bindNextAction={bindNextAction}
        onTableUpdate={handleUpdateTableData}
        onLike={onLike}
        onSelect={onSelect}
        onDelete={onDelete}
        onRestore={onRestore}
        onSaveMessage={onSaveMessage}
        getMessageLogs={getMessageLogs}
        maxHeight={maxHeight}
        setEditableMessage={setEditableMessage}
        MessageCard={MessageCard}
        logsSelector={(state) => state.id8}
        onOpenImages={handleOpenImages}
      />

      <TextLoader
        isLoading={isGenerating}
        labelsArray={loaderLabels}
        scrollableRef={tableWrapperRef}
        disableScrolling
      />
    </div>
  );
};

export default memo(MessagesOutput);
